import { useState } from "react";
import type { CompareV2DispatchType } from "../redux/store";
import { compareClearAll } from "../../../common-deprecated/features/compare/redux/actions/NewCarCompareExternalDataActions";
import type { CarDataType } from "../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import { trackCompareClear, trackCompareClose, trackCompareGradeOpen, trackCompareOpen } from "../utils/tracking";
import { useDispatch } from "../../../shared-logic/redux/store";

type useNewCarHeaderReturnType = {
    clearAll: () => void;
    expandToggleClickHandler: () => void;
    borderClickHandler: (index: number) => void;
    selectGradeOpenIndex: number;
    setSelectGradeOpenIndex: (index: number) => void;
};

const useNewCarHeader = (
    expanded: boolean,
    toggleExpanded: () => void,
    onShowSelectNewGrade: (index: number) => void,
    cars: CarDataType[],
    isLexus?: boolean,
): useNewCarHeaderReturnType => {
    const dispatch = useDispatch<CompareV2DispatchType>();
    // A new grade can be selected from a dropdown, this opens when clicking on the dropdown.
    // Problem is when we scroll down and click on the name in the header we should scroll all the way up,
    // and the dropdown should be open for that car. We use the selectGradeOpenIndex for this
    const [selectGradeOpenIndex, setSelectGradeOpenIndex] = useState<number>(-1);

    const clearAll = (): void => {
        trackCompareClear();
        dispatch(compareClearAll());
    };

    const borderClickHandler = (index: number): void => {
        if ((expanded || isLexus) && selectGradeOpenIndex < 0 && (!cars[index] || !cars[index].loading)) {
            if (isLexus && !expanded) toggleExpanded();
            trackCompareGradeOpen();
            onShowSelectNewGrade(index);
            setSelectGradeOpenIndex(index);
        }
    };

    const expandToggleClickHandler = (): void => {
        if (expanded) {
            trackCompareClose();
        } else {
            trackCompareOpen(cars.length);
        }
        toggleExpanded();
    };

    return {
        borderClickHandler,
        expandToggleClickHandler,
        clearAll,
        selectGradeOpenIndex,
        setSelectGradeOpenIndex: (index: number) => {
            setSelectGradeOpenIndex(index);
        },
    };
};

export default useNewCarHeader;
